import axios from '@/util/request';

export function getDepotInfo(parameter) {
  //库房管理-仓库查询
  return axios({
    url: '/ims/depot/getDepotInfo',
    method: 'get',
    params: parameter,
  })
}

export function createDepot(parameter) {
  //库房管理-新建仓库
  return axios({
    url: '/ims/depot',
    method: 'post',
    data: parameter
  })
}

export function getCabinetInfo(id) {
  //库房管理-仪器柜和对应格口信息
  return axios({
    url: '/ims/cabinet/getCabinetDtoList/' + id,
    method: 'get',
  })
}

export function createCabinet(parameter) {
  //库房管理-新增仪器柜
  return axios({
    url: '/ims/cabinet',
    method: 'post',
    data: parameter
  })
}

export function getBoxInfo(id) {
  //库房管理-获取仪器柜信息
  return axios({
    url: '/ims/box/getCabinetInfo/' + id,
    method: 'get',
  })
}

export function getPowerList(parameter) {
  //库房管理-获取电源控制器列表
  return axios({
    url: '/ims/powerSwitch/pagePower',
    method: 'get',
    params: parameter
  })
}

export function createPower(parameter) {
  //库房管理-新增电源控制器
  return axios({
    url: '/ims/powerSwitch/add',
    method: 'post',
    data: parameter
  })
}

export function getPowerInfo(id) {
  //库房管理-获取电源控制器信息
  return axios({
    url: '/ims/powerSwitch/' + id,
    method: 'get',
  })
}

export function PowerOn(id) {
  //库房管理-电源控制器开启
  return axios({
    url: '/ims/powerSwitch/open/' + id,
    method: 'get',
  })
}

export function PowerOff(id) {
  //库房管理-电源控制器关闭
  return axios({
    url: '/ims/powerSwitch/stop/' + id,
    method: 'get',
  })
}

export function deletePower(id) {
  //库房管理-删除电源控制器
  return axios({
    url: '/ims/powerSwitch/' + id,
    method: 'DELETE',
  })
}

export function createTherm(parameter) {
  //库房管理-创建温湿度传感器
  return axios({
    url: '/ims/thermometer/add',
    method: 'post',
    data: parameter
  })
}

export function getThermList(parameter) {
  //库房管理-获取温湿度数据
  return axios({
    url: `/ims/thermometer/getThermometerDataList/${parameter.depotId}/${parameter.startTime}/${parameter.endTime}`,
    method: 'get',
  })
}

export function updateTherm(parameter) {
  //库房管理-修改温湿度传感器
  return axios({
    url: '/ims/thermometer/update',
    method: 'put',
    data: parameter
  })
}

export function getInstrument(parameter) {
  //库房管理-查找仪器
  return axios({
    url: '/ims/Instrument/GetInstrumentList',
    method: 'get',
    params: parameter,
  })
}

export function updateAsysnc(parameter) {
  //库房管理-更新仓库主体信息
  return axios({
    url: '/ims/depot',
    method: 'put',
    data: parameter
  })
}

export function getDepot(id) {
  //库房管理-获取当前编辑仓库详情
  return axios({
    url: '/ims/depot/GetDepotById/' + id,
    method: 'get',
  })
}

export function boxBind(parameter) {
  //库房管理-仪器绑格
  return axios({
    url: `/ims/box/bind/${parameter.instrumentId}/${parameter.boxid}`,
    method: 'get',
  })
}

export function boxUnbind(instrumentId) {
  //库房管理-解绑格口
  return axios({
    url: `/ims/box/unbindBox/${instrumentId}`,
    method: 'get',
  })
}

export function powerUnbind(instrumentId) {
  //库房管理-电源控制器与仪器解除绑定
  return axios({
    url: '/ims/powerSwitch/untying/',
    method: 'get',
    params: { "instrumentId": instrumentId }
  })
}

export function powerBind(parameter) {
  //库房管理-电源控制器与仪器绑定
  return axios({
    url: '/ims/powerSwitch/bind',
    method: 'put',
    params: parameter
  })
}

export function powerUpdate(parameter) {
  //库房管理-电源控制器信息更新
  return axios({
    url: '/ims/powerSwitch/update',
    method: 'put',
    data: parameter
  })
}

export function getThermInfo(id) {
  //库房管理-获取温湿度传感器信息
  return axios({
    url: '/ims/thermometer/getThermInfo/' + id,
    method: 'get',
  })
}

export function getHkiStreamToken(parameter) {
  //库房管理-获取海康威视视频认证流
  return axios({
    url: '/ims/HikMonitor/GetStreamToken',
    method: 'get',
    params: parameter,
  })
}

export function getDevicesPassagewayList(parameter) {
  //库房管理-获取监控通道
  return axios({
    url: '/ims/HikMonitor/api/v1/open/basic/channels/list',
    method: 'get',
    params: parameter,
  })
}

export function cabinetUpdate(parameter) {
  //库房管理-仪器柜信息更新
  return axios({
    url: '/ims/cabinet',
    method: 'put',
    data: parameter
  })
}

export function cabinetDelete(id) {
  //库房管理-仪器柜-删除
  return axios({
    url: '/ims/cabinet/' + id,
    method: 'DELETE',
  })
}
export function shelfPage(parameter) {
  return axios({
    url: '/ims/shelf/page',
    method: 'get',
    params: parameter,
  })
}
export function shelfDelete(id) {
  //库房管理-仪器柜-删除
  return axios({
    url: '/ims/shelf/' + id,
    method: 'DELETE',
  })
}
export function storeDelete(id) {
  //库房管理-仪器柜-删除
  return axios({
    url: '/ims/store/' + id,
    method: 'DELETE',
  })
}
export function getMaxNumber(parameter) {
  return axios({
    url: '/ims/shelf/getMaxNumber',
    method: 'get',
    params: parameter,
  })
}
export function getStoreMaxNumber(parameter) {
  return axios({
    url: '/ims/store/getMaxNumber',
    method: 'get',
    params: parameter,
  })
}


export function addShelf(parameter) {

  return axios({
    url: '/ims/shelf',
    method: parameter.id?'put':'post',
    data: parameter
  })
}
export function getDetail(id) {

  return axios({
    url: '/ims/shelf/' + id,
    method: 'get',
  })
}
export function getShelfById(parameter) {
  return axios({
    url: '/ims/store/getShelfById',
    method: 'get',
    params: parameter,
  })
}
export function storeShelf(parameter) {
  return axios({
    url: '/ims/store',
    method: parameter.id?'put':'post',
    data: parameter
  })
}
export function getFreeInsList(parameter) {
  return axios({
    url: '/ims/instrument/getFreeInsList5',
    method: 'post',
    data: parameter
  })
}
export function exportQrcode(parameter) {
  return axios({
    url: '/ims/shelf/exportQrcode',
    method: 'post',
    responseType: 'blob',
    data: parameter,
    timeout: 60 * 60 * 1000
  })
}
export function exportQrcodeStore(parameter) {
  return axios({
    url: '/ims/store/exportQrcode',
    method: 'post',
    responseType: 'blob',
    data: parameter,
    timeout: 60 * 60 * 1000
  })
}
export function storeBind(parameter) {
  return axios({
    url: '/ims/store/bind',
    method: 'put',
    data: parameter
  })
}
export function unBind(parameter) {
  return axios({
    url: '/ims/store/unBind',
    method: 'put',
    data: parameter
  })
}




// WEBPACK FOOTER //
// ./src/api/warehouse.js